module.exports = __webpack_public_path__ + "static/media/html-css.db6ff7b0.png";